import Dropdown from "bootstrap/js/dist/dropdown";
let toggleFuncDd = Dropdown.prototype.constructor.prototype.toggle;
Dropdown.prototype.constructor.prototype.toggle = function () {
    if (event && event.target && event.target.hasOwnProperty('classList') && (event.target.classList.contains('js-no-collapse') || event.target.classList.contains('js-clear-filter'))) {
        return;
    }
    toggleFuncDd.call(this);
}

export default Dropdown;